import React, {AllHTMLAttributes, FC, ReactNode, useContext} from "react";
import './NavigationDropdown.scoped.scss';
import {useLocation} from "react-router-dom";
import {CustomLink, Dropdown, Image} from "../../common";
import {DropdownContext} from "../../common/generics/Dropdown/composables/DropdownContext";
import dropdownArrow from "../../../assets/images/svg/mobile-arrow.svg";
import {cn, resultIf, RouteDictionary} from "../../../utils";

type RouteMapObject = {
    text: string;
    route: RouteDictionary;
}

export type RouteMap = {
    [key: string]: RouteMapObject;
}

export interface NavigationDropdownProps extends AllHTMLAttributes<HTMLDivElement> {
    routesMap: RouteMap;
    placeholderText: ReactNode;
}

const NavigationDropdown: FC<NavigationDropdownProps> = ({routesMap, placeholderText, ...props}) => {
  const {pathname} = useLocation();
  const renderHead = () => {
    const element = routesMap[pathname];
    return element === undefined ? placeholderText : element.text;
  };
  const renderLinks = () => {
    const {toggle} = useContext(DropdownContext);
    return Object.entries(routesMap).map((entry) => {
      return <li key={entry[1].text} className="navigation-dropdown__element">
        <CustomLink
          to={entry[1].route}
          className="navigation-dropdown__link"
          onClick={toggle}
        >
          { entry[1].text }
        </CustomLink>
      </li>;
    });
  };
  return (
    <Dropdown className={cn("navigation-dropdown", props.className)}>
      <Dropdown.Head className="navigation-dropdown__head">
        <DropdownContext.Consumer>
          { ({active}) => <>
            <div className="navigation-dropdown__active">
              { renderHead() }
            </div>
            <Image
              src={dropdownArrow}
              className={cn(
                "navigation-dropdown__image",
                resultIf(active, "active")
              )}
            />
          </> }
        </DropdownContext.Consumer>
      </Dropdown.Head>
      <Dropdown.Content className="navigation-dropdown__content">
        <ul className="navigation-dropdown__list">
          { renderLinks() }
        </ul>
      </Dropdown.Content>
    </Dropdown>
  );
};

export default NavigationDropdown;